import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";
import { ModalContext } from "../store/ModalContext";
import type { ModalButton } from "../utils/types";

type ModalProps = {
  title?: ReactNode;
  body: ReactNode;
  buttons?: ModalButton[];
};
const Modal = ({
  title,
  body,
  buttons,
  showCloseButton = false,
}: ModalProps & { showCloseButton?: boolean }) => {
  const { closeModal } = useContext(ModalContext);
  const [loadingButtonIndex, setLoadingButtonIndex] = useState<number | null>(
    null,
  );

  const renderedButtons =
    buttons && buttons.length > 0
      ? buttons.map((btn, index) => {
          const isLoading = loadingButtonIndex === index;
          const label =
            isLoading && btn.loadingText ? btn.loadingText : btn.text;

          return (
            <button
              key={`${btn.text}-${index}`}
              type="button"
              className="btn equal-btns"
              disabled={loadingButtonIndex !== null}
              onClick={async () => {
                if (loadingButtonIndex !== null) return;
                if (!btn.loadingText) {
                  await btn.callback();
                  return;
                }
                setLoadingButtonIndex(index);
                try {
                  await btn.callback();
                } finally {
                  setLoadingButtonIndex(null);
                }
              }}
            >
              {label}
            </button>
          );
        })
      : null;

  return createPortal(
    <div className="modal-overlay" role="dialog" aria-modal="true">
      <div className="modal-content modal-scrollable-content hidden-scrollbar">
        <div className="modal-content-wrapper">
          {showCloseButton && (
            <div className="exit-btn-absolute">
              <button className="btn" onClick={closeModal}>
                <FontAwesomeIcon icon={faXmark} style={{ color: "#ffffff" }} />
              </button>
            </div>
          )}
          {title != null && title !== "" ? <h3>{title}</h3> : null}
          <div>{body}</div>
          {renderedButtons && (
            <div className="buttons-footer">{renderedButtons}</div>
          )}
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default Modal;
